import React from "react";
import { Container } from "@mui/material";
import Page from "../../components/Page";
import { Provider, ErrorBoundary } from "@rollbar/react";

const ErrorDisplay = () => (
  <Page title={"Something went wrong"}>
    <Container sx={{ mt: 5 }}>
      <h1>Something went wrong.</h1>
      <div>Try refreshing the browser</div>
      <div style={{ marginTop: 30 }}>
        If refreshing the browser doesn't work, there might be a data issue.
        <br />
        <span
          style={{ fontWeight: "bold", cursor: "pointer" }}
          onClick={() => {
            localStorage.removeItem("persist:playcreator");
            location.reload(); //eslint-disable-line
          }}
        >
          Click here
        </span>{" "}
        to delete your current play and reset default settings.
      </div>
    </Container>
  </Page>
);

export default function RollbarErrorBoundary(props) {
  let rollbarConfig = {
    accessToken: "207b0cae5369443a8c604ffb6bc80e2b",
    environment: props.environment ?? "Coaching App",
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: process.env.NODE_ENV === "production",
    hostSafeList: ["app.thehoopsgeek.com", "thehoopsgeek.b-cdn.net"],
  };

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary fallbackUI={ErrorDisplay}>{props.children}</ErrorBoundary>
    </Provider>
  );
}
